import type { TAvatar } from "@common";
import { MutableRefObject } from "react";

export const tabsList = [
	"appearance",
	"scene",
	"preview",
] as const;
export type TTabs = typeof tabsList;
export type TTab = TTabs[number];

export interface FineTuningState {
	eleven_multilingual_v2?: string;
	eleven_turbo_v2_5?: string;
	eleven_flash_v2_5?: string;
	eleven_v2_flash?: string;
	eleven_v2_5_flash?: string;
	eleven_turbo_v2?: string;
	eleven_flash_v2?: string;
}

export interface FineTuningProgress {
	eleven_flash_v2_5?: number;
	eleven_v2_flash?: number;
	eleven_flash_v2?: number;
	eleven_v2_5_flash?: number;
}

export interface FineTuningMessage {
	eleven_flash_v2_5?: string;
	eleven_v2_flash?: string;
	eleven_flash_v2?: string;
	eleven_v2_5_flash?: string;
}

export interface FineTuning {
	is_allowed_to_fine_tune: boolean;
	state: FineTuningState;
	verification_failures: any[];
	verification_attempts_count: number;
	manual_verification_requested: boolean;
	language: string;
	progress: FineTuningProgress;
	message: FineTuningMessage;
	dataset_duration_seconds: number | null;
	verification_attempts: any[] | null;
	slice_ids: any[] | null;
	manual_verification: any | null;
	max_verification_attempts: number;
	next_max_verification_attempts_reset_unix_ms: number;
}

export interface Labels {
	accent: string;
	description: string;
	age: string;
	gender: string;
	use_case: string;
}

export interface VoiceVerification {
	requires_verification: boolean;
	is_verified: boolean;
	verification_failures: any[];
	verification_attempts_count: number;
	language: string | null;
	verification_attempts: any[] | null;
}

export interface VoiceTypes {
	voice_id: string;
	name: string;
	preview_url: string;
	gender: string;
	useCase: string;
	temper: string;
}

export interface VoiceItemTypes {
	value: string;
	description: string;
	onClick: (value: string) => void;
	preview_url: string;
	useCase: string;
	temper: string;
}

export interface VoiceItemProps extends VoiceItemTypes {
	active: boolean;
	index: number;
}

export interface ModalProps {
	onClose: () => void;
}

interface Thumbnail {
	success: boolean;
	path: string;
	camera: string;
	height: number;
	scene: string;
	width: number;
}

export interface Character {
	_id: string;
	id: string;
	name: string;
	type: "character";
	package: string;
	project: string;
	version: string;
	created: string;
	updated?: string;
	thumbnails: Thumbnail[];
}

export interface Avatar {
	value: string;
	description: string;
	url: string;
}

export interface BrainData {
	brain_id: string;
	llm_id: string;
	prompt_id: string;
}
export interface Scene {
	_id: string;
	id: string;
	name: string;
	type: string;
	package: string;
	project: string;
	version: string;
	created: string;
	thumbnails: string[];
	updated: string;
}

export type Names = "Андрей" | "Игорь" | "Настя" | "Ирина";

export type Gender = "male" | "female";

export type TGenderRu = "Мужской" | "Женский";

export type AvatarPrompts = {
	[key in Gender]: (name: Names) => string;
};

export enum LocalStorageKey {
	PlatformAvatars = "platformAvatars",
	PlatformVoices = "platformVoices",
	PlatformScenes = "platformScenes"
}

export interface AvatarsGenderId {
	id: "metahumans/andrey" | "metahumans/nastya" | "metahumans/irina" | "metahumans/igor";
	gender: "male" | "female";
	name: "Андрей" | "Настя" | "Ирина" | "Игорь";
}

export type AvatarName = "irina" | "andrey" | "nastya" | "igor";

export interface IAvatarGender extends Avatar {
	gender: string;
	avatarRuName: string;
}
